function updateCountdown() {
    const countdownElement = document.querySelector('[data-start][data-end]');
    if (!countdownElement) {
        return;
    }

    const parseWithDSTDate = (dateString) => {
        const date = new Date(dateString);
        const year = date.getUTCFullYear();
        const dstStart = new Date(Date.UTC(year, 2, 8));
        while (dstStart.getUTCDay() !== 0) {
            dstStart.setUTCDate(dstStart.getUTCDate() + 1);
        }
        const offset = date < dstStart ? 5 : 4;
        return date.getTime() + (offset * 60 * 60 * 1000);
    };

    const startDate = parseWithDSTDate(countdownElement.dataset.start);
    const endDate = parseWithDSTDate(countdownElement.dataset.end);
    const now = new Date().getTime();

    if (now < startDate) {
        return;
    }

    const timeRemaining = endDate - now;

    const updateElements = (selector, value) => {
        document.querySelectorAll(selector).forEach((el) => {
            // eslint-disable-next-line no-param-reassign
            el.textContent = value;
        });
    };

    if (timeRemaining <= 0) {
        updateElements('#timer-days .timer-value', '0');
        updateElements('#timer-hours .timer-value', '0');
        updateElements('#timer-minutes .timer-value', '0');
        return;
    }

    const minutes = Math.floor((timeRemaining / (1000 * 60)) % 60);
    const hours = Math.floor((timeRemaining / (1000 * 60 * 60)) % 24);
    const days = Math.floor(timeRemaining / (1000 * 60 * 60 * 24));

    updateElements('#timer-days .timer-value', String(days));
    updateElements('#timer-hours .timer-value', String(hours).padStart(2, '0'));
    updateElements('#timer-minutes .timer-value', String(minutes).padStart(2, '0'));
}

updateCountdown();

setInterval(updateCountdown, 1000);
